// NOTE: This assumes the iframe is already loaded. If you need to send a message
// at page load time, add a load event listener to the iframe before posting.
function postMessageToWorkflowEditor<T = unknown>(type: string, payload?: T) {
  const iframe = document.querySelector<HTMLIFrameElement>('iframe[title="Workflow Editor"]');
  iframe?.contentWindow?.postMessage({ type, payload }, window.location.origin);
}

export default postMessageToWorkflowEditor;
